module.exports = __webpack_public_path__ + "img/Logo-NameBlack-1024x337.d1ad462f.png";